import * as Yup from "yup";

export const validationSchema = Yup.object({
  username: Yup.lazy((value) => {
    if (isNaN(parseInt(value)) && value !== undefined) {
      return Yup.string().email("ایمیل را صحیح وارد کنید");
    }

    return Yup.string()
      .matches(
        "^[0][9][0-9]{9}$" || "^[۰][۹][۰-۹]{9}$",
        "شماره اشتباه است (09xxxx)"
      )
      .required("شماره موبایل یا ایمیل خود را وارد کنید");
  }),
});

export const initialValue = {
  username: "",
};
